module.exports = __webpack_public_path__ + "c1896adc966cb62dabec5f588ea02012.svg";